<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div
      class="modal fade"
      id="stickets-columns"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div class="text-center">
              <h4 class="mb-2">
                {{ $t("support_tickets.support_tickets_columns") }}
              </h4>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Profile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-lifebuoy"></i>
                        <span class="custom-option-title">
                          {{ $t("support_tickets.id") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.id.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Profile"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="firstname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-at"></i>
                        <span class="custom-option-title">
                          {{ $t("support_tickets.username") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.username.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="firstname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lastname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-timeline-event-exclamation"></i>
                        <span class="custom-option-title">
                          {{ $t("support_tickets.issue") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        v-model="columns.issue.enabled"
                        @change="updateColumns"
                        id="lastname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Price"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-phone-call"></i>
                        <span class="custom-option-title">
                          {{ $t("support_tickets.phone") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        v-model="columns.phone.enabled"
                        @change="updateColumns"
                        id="Price"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="prefix"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-map"></i>
                        <span class="custom-option-title">
                          {{ $t("support_tickets.address") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        v-model="columns.address.enabled"
                        @change="updateColumns"
                        id="prefix"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lineNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-sort-descending-2"></i>
                        <span class="custom-option-title">
                          {{ $t("support_tickets.priority.priority") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        v-model="columns.priority.enabled"
                        @change="updateColumns"
                        id="lineNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-progress"></i>
                        <span class="custom-option-title">
                          {{ $t("support_tickets.status") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        v-model="columns.status.enabled"
                        @change="updateColumns"
                        id="portNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Notes"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-note"></i>
                        <span class="custom-option-title">
                          {{ $t("support_tickets.notes") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        v-model="columns.notes.enabled"
                        @change="updateColumns"
                        id="Notes"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ip"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-message"></i>
                        <span class="custom-option-title">
                          {{ $t("support_tickets.ssr_comment") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.ssr_notes.enabled"
                        @change="updateColumns"
                        value=""
                        id="ip"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ASessions"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-calendar-plus"></i>
                        <span class="custom-option-title">
                          {{ $t("support_tickets.created_at") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.created_at.enabled"
                        @change="updateColumns"
                        value=""
                        id="ASessions"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ticketAdd
      v-if="showAddTicket"
      :ticket="selectedData"
      @updated="
        $router.push({ query: {} });
        applyFilters();
      "
    />

    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0"
              bis_skin_checked="1"
            >
              <!-- <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-primary waves-effect waves-light"
                    tabindex="0"
                    type="button"
                    @click="showAddTicketDialog"
                    v-if="
                      hasPrivilege('support_tickets_create_support_tickets')
                    "
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{
                        $t("support_tickets.add_ticket")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div> -->
            </div>
            <div
              class="col-12 col-md-8 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('accounts_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="
                          export_csv('accounts_table', 'accounts')
                        "
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('accounts_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    v-model="filters.search_query"
                    @change="applyFilters"
                    v-if="
                      hasPrivilege(
                        'support_tickets_view_search_support_tickets',
                      )
                    "
                    :placeholder="$t('control.search')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6" bis_skin_checked="1">
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    v-model="filters.rows"
                    @change="applyFilters"
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#stickets-columns"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-1 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-n6 mt-md-0"
              bis_skin_checked="1"
            ></div>

            <div
              class="col-12 col-md-6 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                id="DataTables_Table_0"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th>
                      <div class="dropdown" v-if="selection_array.length > 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li
                            v-if="
                              hasPrivilege(
                                'support_tickets_delete_support_tickets',
                              )
                            "
                          >
                            <button
                              @click="groupDelete()"
                              v-if="
                                hasPrivilege(
                                  'support_tickets_delete_support_tickets',
                                )
                              "
                              class="dropdown-item text-danger"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <th>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      />
                    </th>
                    <th class="sorting" v-if="columns.id.enabled">
                      {{ $t("support_tickets.id") }}
                    </th>
                    <th class="sorting" v-if="columns.username.enabled">
                      {{ $t("support_tickets.username") }}
                    </th>
                    <th class="sorting" v-if="columns.issue.enabled">
                      {{ $t("support_tickets.issue") }}
                    </th>
                    <th class="sorting" v-if="columns.phone.enabled">
                      {{ $t("support_tickets.phone") }}
                    </th>
                    <th class="sorting" v-if="columns.address.enabled">
                      {{ $t("support_tickets.address") }}
                    </th>
                    <th class="sorting" v-if="columns.priority.enabled">
                      {{ $t("support_tickets.priority.priority") }}
                    </th>
                    <th class="sorting" v-if="columns.status.enabled">
                      {{ $t("support_tickets.status") }}
                    </th>
                    <th class="sorting" v-if="columns.notes.enabled">
                      {{ $t("support_tickets.notes") }}
                    </th>
                    <th class="sorting" v-if="columns.ssr_notes.enabled">
                      {{ $t("support_tickets.ssr_comment") }}
                    </th>
                    <th class="sorting" v-if="columns.created_at.enabled">
                      {{ $t("support_tickets.created_at") }}
                    </th>
                  </tr>
                  <tr
                    v-if="
                      hasPrivilege(
                        'support_tickets_view_search_support_tickets',
                      )
                    "
                  >
                    <th></th>
                    <th></th>
                    <th
                      v-if="columns.id.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        v-if="columns.id.enabled"
                        v-model="filters.id"
                        @change="applyFilters"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.username.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        v-if="columns.username.enabled"
                        v-model="filters.username"
                        @change="applyFilters"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th v-if="columns.issue.enabled"></th>
                    <th
                      v-if="columns.phone.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        v-if="columns.phone.enabled"
                        v-model="filters.phone"
                        @change="applyFilters"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.address.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        v-if="columns.address.enabled"
                        v-model="filters.address"
                        @change="applyFilters"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th v-if="columns.priority.enabled"></th>
                    <th v-if="columns.status.enabled"></th>
                    <th v-if="columns.notes.enabled"></th>
                    <th v-if="columns.ssr_notes.enabled"></th>

                    <th
                      v-if="columns.created_at.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        v-if="columns.created_at.enabled"
                        v-model="filters.created_at"
                        @change="applyFilters"
                        class="form-control"
                        placeholder="YYYY-MM-DD"
                        id="flatpickr-datetime"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th
                      v-for="(item, index) in Object.values(columns).filter(
                        (col) => col?.enabled === true,
                      ).length"
                      :key="index"
                    >
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(ticket, index) in dataList" :key="ticket.id">
                    <td>
                      <div class="flex gap-1">
                        <button
                          @click="showAddTicketDialog(ticket)"
                          class="dropdown-item"
                          :title="$t('actions.view')"
                        >
                          <i class="ti ti-eye me-2"></i>{{}}
                        </button>
                        <button
                          class="dropdown-item text-success"
                          @click="showNotifyDialog(ticket)"
                          :title="$t('actions.notify')"
                        >
                          <i class="ti ti-notification me-2"></i>
                        </button>
                        <button
                          @click="deleteData(ticket)"
                          class="dropdown-item text-danger"
                          :title="$t('actions.delete')"
                        >
                          <i class="ti ti-trash me-2"></i>
                        </button>
                      </div>
                      <!-- <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li
                            v-if="
                              hasPrivilege(
                                'support_tickets_edit_support_tickets',
                              )
                            "
                          ></li>
                          <li
                            v-if="
                              hasPrivilege(
                                'notifications_edit_manual_notifications',
                              ) ||
                                hasPrivilege('notifications_push_notifications')
                            "
                          ></li>
                          <li
                            v-if="
                              hasPrivilege(
                                'support_tickets_delete_support_tickets',
                              )
                            "
                          ></li>
                        </ul>
                      </div> -->
                    </td>
                    <td scope="row">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="ticket.selected"
                        @click="selectData(ticket)"
                      />
                    </td>
                    <td scope="row" v-if="columns.id.enabled">
                      <a
                        v-if="
                          hasPrivilege('support_tickets_edit_support_tickets')
                        "
                        @click.prevent="showAddTicketDialog(ticket)"
                        >{{ ticket.id }}</a
                      >
                      <div v-else>{{ ticket.id }}</div>
                    </td>
                    <td scope="row" v-if="columns.username.enabled">
                      <a
                        v-if="
                          hasPrivilege('support_tickets_edit_support_tickets')
                        "
                        @click.prevent="showAddTicketDialog(ticket)"
                      >
                        {{ ticket.account_username }}
                      </a>
                      <div v-else>{{ ticket.account_username }}</div>
                    </td>
                    <td v-if="columns.issue.enabled">{{ ticket.issue }}</td>
                    <td v-if="columns.phone.enabled">{{ ticket.phone }}</td>
                    <td v-if="columns.address.enabled">{{ ticket.address }}</td>
                    <td v-if="columns.priority.enabled">
                      <span
                        class="badge bg-label-secondary me-1"
                        v-if="ticket.priority == '0'"
                        >{{ $t("support_tickets.priority.low") }}</span
                      >
                      <span
                        class="badge bg-label-info me-1"
                        v-if="ticket.priority == '1'"
                        >{{ $t("support_tickets.priority.normal") }}</span
                      >
                      <span
                        class="badge bg-label-warning me-1"
                        v-if="ticket.priority == '2'"
                        >{{ $t("support_tickets.priority.high") }}</span
                      >
                    </td>
                    <td v-if="columns.status.enabled">
                      <span
                        class="badge bg-label-primary me-1"
                        v-if="ticket.status == 'new'"
                        >{{ $t("support_tickets.new") }}</span
                      >
                      <span
                        class="badge bg-label-warning me-1"
                        v-if="ticket.status == 'in_progress'"
                        >{{ $t("support_tickets.in_progress") }}</span
                      >
                      <span
                        class="badge bg-label-success me-1"
                        v-if="ticket.status == 'resolved'"
                        >{{ $t("support_tickets.resolved") }}</span
                      >
                      <span
                        class="badge bg-label-danger me-1"
                        v-if="ticket.status == 'failed'"
                        >{{ $t("support_tickets.failed") }}</span
                      >
                    </td>
                    <td v-if="columns.notes.enabled">
                      <div
                        v-for="(note, index) in ticket.notes_array"
                        :key="index"
                      >
                        <span class="badge bg-label-warning m-1">
                          {{ $t(`support_tickets.notes_array.${note}`) }}
                        </span>
                      </div>
                      {{ ticket.notes }}
                    </td>
                    <td v-if="columns.ssr_notes.enabled">
                      {{ ticket.ssr_notes }}
                    </td>
                    <td v-if="columns.created_at.enabled">
                      {{ formatDate(ticket.created_at) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_table,
} from "../global_constants.js";
import ticketAdd from "../components/modals/ticket-add.vue";
export default {
  components: {
    ticketAdd,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  name: "SupportTickets",
  data() {
    return {
      dataList: null,
      meta: { last_page: 0 },
      selectedData: null,
      showDetails: false,
      showDelete: false,
      showDeleteAll: false,
      showContext: false,
      showNotification: false,
      showAddTicket: false,
      loading: true,
      showFilters: false,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
        save: false,
        id: "",
        username: "",
        issue: "",
        phone: "",
        address: "",
        priority: "",
        status: "",
        notes: "",
        ssr_notes: "",
        created_at: "",
        search_query: null,
      },
      checkedBox: true,
      allSelected: false,
      showColumnsSelect: false,
      columns: {
        id: { name: this.$t("support_tickets.id"), enabled: true },
        username: { name: this.$t("support_tickets.username"), enabled: true },
        issue: { name: this.$t("support_tickets.issue"), enabled: true },
        phone: { name: this.$t("support_tickets.phone"), enabled: false },
        address: { name: this.$t("support_tickets.address"), enabled: false },
        priority: {
          name: this.$t("support_tickets.priority.priority"),
          enabled: true,
        },
        status: {
          name: this.$t("support_tickets.status"),
          enabled: true,
        },
        notes: { name: this.$t("support_tickets.notes"), enabled: false },
        ssr_notes: {
          name: this.$t("support_tickets.ssr_comment"),
          enabled: false,
        },
        created_at: {
          name: this.$t("control.created_at"),
          enabled: true,
        },
      },
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      loading_overlay: false,
    };
  },
  async created() {
    this.prepareFilters();
    this.prepareColumns();
    if (this.$route.query.id) {
      this.filters.id = this.$route.query.id;
      this.columns.id.enabled = true;
    }
    if (this.$route.query.ticket_id) {
      this.showAddTicketDialog({ id: this.$route.query.ticket_id });
    }
    this.applyFilters();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetchData() {
      if (this.filters.rows > 0 || this.filters.page > 0) {
        this.fetchDataPortion(this.filters.rows, this.filters.page);
        this.selection_array = [];
        return;
      }
      const response = await axios.get("support");
      this.dataList = response.data.data;
      this.meta = response.data.meta;
      this.loading = false;
    },
    prepareFilters() {
      var filters = localStorage.getItem("support_tickets_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    prepareColumns() {
      var columns = localStorage.getItem("support_tickets_columns");
      if (columns != null) {
        columns = JSON.parse(columns);
        this.columns = {
          id: {
            name: this.$t("support_tickets.id"),
            enabled: columns[0].enabled ?? this.columns.id.enabled,
          },
          username: {
            name: this.$t("support_tickets.username"),
            enabled: columns[1].enabled ?? this.columns.username.enabled,
          },
          issue: {
            name: this.$t("support_tickets.issue"),
            enabled: columns[2].enabled ?? this.columns.issue.enabled,
          },
          phone: {
            name: this.$t("support_tickets.phone"),
            enabled: columns[3].enabled ?? this.columns.phone.enabled,
          },
          address: {
            name: this.$t("support_tickets.address"),
            enabled: columns[4].enabled ?? this.columns.address.enabled,
          },
          priority: {
            name: this.$t("support_tickets.priority.priority"),
            enabled: columns[5].enabled ?? this.columns.priority.enabled,
          },
          status: {
            name: this.$t("support_tickets.status"),
            enabled: columns[6].enabled ?? this.columns.status.enabled,
          },
          notes: {
            name: this.$t("support_tickets.notes"),
            enabled: columns[7].enabled ?? this.columns.notes.enabled,
          },
          ssr_notes: {
            name: this.$t("support_tickets.ssr_comment"),
            enabled: columns[8].enabled ?? this.columns.ssr_notes.enabled,
          },
          created_at: {
            name: this.$t("control.created_at"),
            enabled: columns[9].enabled ?? this.columns.created_at.enabled,
          },
        };
      }
    },
    async applyFilters() {
      this.loading = true;
      var requestString = "support?filters=1";
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.username != "")
        requestString += `&username=${this.filters.username}`;
      if (this.filters.id != "") requestString += `&id=${this.filters.id}`;
      if (this.filters.address != "")
        requestString += `&address=${this.filters.address}`;
      if (this.filters.created_at != "")
        requestString += `&created_at=${this.filters.created_at}`;
      if (this.filters.status != "")
        requestString += `&status=${this.filters.status}`;
      if (this.filters.priority != "")
        requestString += `&priority=${this.filters.priority}`;
      if (this.filters.ssr_notes != "")
        requestString += `&ssr_notes=${this.filters.ssr_notes}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      if (this.filters.save)
        localStorage.setItem(
          "support_tickets_filters",
          JSON.stringify(this.filters),
        );
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      if (this.sort_col) {
        if (this.sort_dir == "ASC") {
          this.dataList.sort((a, b) =>
            a[this.sort_col] > b[this.sort_col]
              ? 1
              : b[this.sort_col] > a[this.sort_col]
              ? -1
              : 0,
          );
        } else {
          this.dataList.sort((a, b) =>
            a[this.sort_col] < b[this.sort_col]
              ? 1
              : b[this.sort_col] < a[this.sort_col]
              ? -1
              : 0,
          );
        }
      }
      this.meta = response.data.meta;
      this.loading = false;
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(async () => {
      //   const response = await axios.get(requestString);
      //   this.dataList = response.data.data;
      //   if (this.filters.save)
      //     localStorage.setItem(
      //       "support_tickets_filters",
      //       JSON.stringify(this.filters)
      //     );
      //   if (this.dataList.length < 1 && this.filters.page != 1) {
      //     this.filters.page = 1;
      //     this.applyFilters();
      //   }
      //   if (this.sort_col) {
      //     if (this.sort_dir == "ASC") {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] > b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] > a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     } else {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] < b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] < a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     }
      //   }
      //   this.meta = response.data.meta;
      //   this.loading = false;
      // }, 1000);
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.applyFilters();
    },
    async showAddTicketDialog(ticket = null) {
      this.showAddTicket = true;
      this.selectedData = ticket;
      if (ticket) {
        await this.$router.push({
          query: { ticket_id: ticket.id },
        });
      }
      await this.$nextTick();
      var modalElement = document.getElementById("add-ticket");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAddTicket = false;
      });
      modalInstance.show();
    },
    async showNotifyDialog(ticket) {
      const { value: formValues } = await this.$swal.fire({
        title:
          this.$t("support_tickets.send_notification_to_account") +
          " " +
          ticket.account_username,
        html: `
    <div class="p-4">
      <div>
        <label>${this.$t("support_tickets.title")}</label>
        <input id="swal-input1" class="form-control mb-4">
      </div>
      <div>
        <label>${this.$t("support_tickets.body")}</label>
        <textarea id="swal-input2" class="form-control mb-4"></textarea>
      </div>
    </div>
    
  `,
        confirmButtonText: this.$t("support_tickets.send"),
        focusConfirm: false,
        preConfirm: () => {
          return [
            document.getElementById("swal-input1").value,
            document.getElementById("swal-input2").value,
          ];
        },
      });
      if (formValues && formValues[0] != "" && formValues[1] != "") {
        const response = await axios.post("notifications", {
          account_id: ticket.account.id,
          type: "account",
          title: formValues[0],
          body: formValues[1],
        });
        if (response.status == 200) {
          this.$notify({
            text: this.$t("support_tickets.notification_sent_successfully"),
            type: "success",
          });
        } else {
          this.$notify({
            text: this.$t("support_tickets.failed_to_send_notification"),
            type: "danger",
          });
        }
      } else {
        this.$swal.fire(this.$t("support_tickets.both_fields_required"));
      }
    },
    editData(selectedData) {
      this.$store.commit("changeKey");
      this.$router.push(`/services/support/${selectedData.id}/edit`);
    },
    async deleteData(ticket) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("support_tickets.this_will_delete_support_ticket"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`support/${ticket.id}`);
            if (response.status == 200) {
              this.selection_array = [];
              this.fetchData();
            }
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t("support_tickets.support_ticket_has_been_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupDelete() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "support_tickets.this_will_delete_all_selected_support_tickets",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`support/group`, {
              tickets: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t(
                "support_tickets.support_tickets_have_been_deleted",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    formatDate(date) {
      return moment(date).format("yyyy-MM-DD HH:mm");
    },
    openContextMenu(e, data) {
      this.selectedData = data;
      this.$refs.menu.open(e);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    updateColumns(updated) {
      localStorage.setItem(
        "support_tickets_columns",
        JSON.stringify(Object.values(this.columns)),
      );
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    sort(param) {
      this.sort_col = param;
      if (!this.columns[param].sort) {
        this.sort_dir = "ASC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = true;
      } else {
        this.sort_dir = "DESC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = false;
      }
      this.applyFilters();
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem(
        "support_tickets_filters",
        JSON.stringify(this.filters),
      );
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
  },
};
</script>
